import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=e8e90804&scoped=true"
import script from "./reading.vue?vue&type=script&lang=js"
export * from "./reading.vue?vue&type=script&lang=js"
import style0 from "./reading.vue?vue&type=style&index=0&id=e8e90804&prod&lang=scss&scoped=true"
import style1 from "./reading.vue?vue&type=style&index=1&id=e8e90804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e90804",
  null
  
)

export default component.exports